var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.5V3c0-.41.34-.75.75-.75s.75.34.75.75v5.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM11.25 21v-5.5c0-.41.34-.75.75-.75s.75.34.75.75V21c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4zM10 21.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4zM8.6 10.9 3.84 8.15a.742.742 0 0 1-.27-1.02c.21-.36.67-.48 1.02-.27l4.76 2.75A.746.746 0 0 1 8.97 11c-.13 0-.26-.03-.37-.1zM19.42 17.15l-4.76-2.75a.742.742 0 0 1-.27-1.02c.21-.36.67-.48 1.02-.27l4.76 2.75a.746.746 0 0 1-.38 1.39c-.13 0-.26-.03-.37-.1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84 9.88a.742.742 0 0 1-.27-1.02l2-3.46c.21-.36.67-.48 1.02-.27.36.21.48.67.27 1.02l-2 3.46c-.14.24-.4.37-.65.37-.13 0-.26-.03-.37-.1zM18.42 18.88a.742.742 0 0 1-.27-1.02l2-3.46c.21-.36.67-.48 1.02-.27.36.21.48.67.27 1.02l-2 3.46c-.13.24-.39.37-.65.37-.13 0-.26-.03-.37-.1z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32 14.13c-.38-.66-.57-1.37-.57-2.13 0-.76.19-1.47.57-2.12A4.266 4.266 0 0 1 12 7.76c1.51 0 2.92.81 3.68 2.12.38.66.57 1.37.57 2.13 0 .76-.19 1.47-.57 2.12A4.266 4.266 0 0 1 12 16.25c-1.51 0-2.92-.81-3.68-2.12zm1.3-3.5c-.24.42-.37.89-.37 1.37A2.755 2.755 0 0 0 12 14.76a2.755 2.755 0 0 0 0-5.51c-.98 0-1.89.53-2.38 1.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.38 10.62a.746.746 0 0 1 .27-1.02l4.76-2.75a.746.746 0 0 1 .75 1.29l-4.76 2.75c-.11.08-.24.11-.37.11-.26 0-.51-.13-.65-.38zM3.56 16.87a.746.746 0 0 1 .27-1.02l4.76-2.75a.746.746 0 0 1 .75 1.29l-4.76 2.75c-.11.08-.24.11-.37.11-.26 0-.51-.13-.65-.38z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.14 9.6-2-3.46a.746.746 0 0 1 1.29-.75l2 3.46c.21.36.08.82-.27 1.02-.11.08-.24.11-.37.11-.26 0-.51-.13-.65-.38zM4.56 18.6l-2-3.46a.746.746 0 0 1 1.29-.75l2 3.46c.21.36.08.82-.27 1.02a.66.66 0 0 1-.37.11c-.26 0-.51-.13-.65-.38z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSun);
export default __webpack_public_path__ + "static/media/vuesax-outline-sun.369759c949eca78fae5ee5b07a2658b8.svg";
export { ForwardRef as ReactComponent };